import React, { useState, useCallback } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Divider, Box, Link, Typography } from "@material-ui/core";
import ExpandIcon from "@material-ui/icons/Add";
import CollapseIcon from "@material-ui/icons/Remove";
import type { FC } from "react";
import { useStyles, rootClasses, summaryClasses } from "./SettingsAccordion.styles";

export const SettingsAccordion: FC = (props) => {
  const classes = useStyles();
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const onAccordionChange = useCallback(
    (event: {}, expanded: boolean) => {
      setAccordionExpanded(expanded);
    },
    [setAccordionExpanded]
  );

  const Icon = accordionExpanded ? CollapseIcon : ExpandIcon;

  return (
    <Accordion className={classes.root} classes={rootClasses} expanded={accordionExpanded} onChange={onAccordionChange}>
      <AccordionSummary className={classes.summary} expandIcon={<Icon />} classes={summaryClasses}>
        <span>Strictly Necessary Cookies</span>
        <span className="blue">Always Active</span>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Box className={classes.detailsContent}>
          These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in
          response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or
          filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then
          work. These cookies do not store any personally identifiable information.
        </Box>
        <Divider light />
        <Box className={classes.subContainer}>
          <Box className={classes.subSummary}>
            <span>Tealium</span>
            <span className="blue">Always Active</span>
          </Box>
          <Box className={classes.subDetails}>
            Through our service provider Tealium Inc, 11085 Torreyana Road, San Diego, CA, 92121 USA, we use Tealium iQ Tag Management to
            assign tags to our websites and manage them. The tag manager can use the tags to specifically apply analysis and tracking tools
            for us. The tag management system as such does not store any personal data about you. Only anonymous data is generated, which is
            stored locally in the browser in the cookie "utag_main".
            <br />
            <br />
            For further information about Tealium, go to 
            <br />
            <Link className={classes.subLink} target="_blank" href={"https://community.cookiepro.com/s/article/UUID-1e75fb0d-bb79-2af8-cb85-f905d16f1220"}>
              https://community.tealiumiq.com/t5/iQ-Tag-Management/Tealium-Cookies/ta-p/138/
            </Link>
          </Box>
        </Box>
        <Divider light />
        <Box className={classes.subContainer}>
          <Box className={classes.subSummary}>
            <span>OneTrust</span>
            <span className="blue">Always Active</span>
          </Box>
          <Box className={classes.subDetails}>
            As part of the cookie compliance module of our service provider, OneTrust Technology Limited, Dixon House 1 Lloyd´s Avenue,
            London EC3N3DQ, UK, we use cookies to manage your preferences in the cookie settings.
            <br />
            <br />
            For further information on OneTrust, go to
            <br />
            <Link className={classes.subLink} target="_blank" href={"https://community.cookiepro.com/s/article/UUID-1e75fb0d-bb79-2af8-cb85-f905d16f1220"}>
              https://community.cookiepro.com/s/article/UUID-1e75fb0d-bb79-2af8-cb85-f905d16f1220
            </Link>
          </Box>
        </Box>

        {/* <Link target="_blank" href="">
        <Typography variant="body2" component="span" className={classes.vendorDetails}>
          View Vendor Details
        </Typography>
        </Link> */}
      </AccordionDetails>
    </Accordion>
  );
};
